import { FC } from 'react';
import styled from 'styled-components';
import { linkColors, colors, fontSizes } from 'ui/theme';

const StyledA = styled.a`
  color: ${colors.textLink};
  text-decoration: underline;
  word-break: break-word;
  font-size: ${fontSizes.s14};

  && {
    &:hover {
      color: ${linkColors.linkHover};
    }

    &:active {
      color: ${linkColors.linkActive};
    }

    &:focus {
      color: ${linkColors.linkFocus};
      outline: none;
    }
  }
`;

export const NameLabel: FC<React.PropsWithChildren<{ href: string }>> = ({ href, children }) => {
  return <StyledA href={href}>{children}</StyledA>;
};
